import {
  LOGIN_USER,
  LOGIN_ERROR,
  LOGIN_DISABLED,
  LOGOUT_USER,
  UPDATE_USER,
  UPDATE_PROFILE_PICTURE,
  UPDATE_VIEW_MODE,
} from "constants/actionTypes";

import { USER_RANK_ADMIN } from "constants/dbValues";

import { userService } from "services";
import { history } from "utils";
import { notificationActions } from "./notification.actions";

export const userActions = {
  login,
  quickLogin,
  logout,
  update,
  updateCurrentUser,
  updateProfilePicture,
  updateViewMode,
};

function login(email, password) {
  return function (dispatch) {
    userService
      .login(email, password)
      .then((user) => {
        dispatch({ type: LOGIN_USER, payload: user });

        var mode = (user.user_type || {}).rang == USER_RANK_ADMIN ? "admin" : "consultation";
        localStorage.setItem("view_mode", mode);
        dispatch({ type: UPDATE_VIEW_MODE, payload: mode });

        history.push("/");
      })
      .catch((error) => {
        if (error === "Disabled") dispatch({ type: LOGIN_DISABLED, payload: {} });
        else dispatch({ type: LOGIN_ERROR, payload: {} });
      });
  };
}

function quickLogin(userId) {
  return function (dispatch) {
    userService
      .quickLogin(userId)
      .then((user) => {
        dispatch({ type: LOGIN_USER, payload: user });

        var mode = (user.user_type || {}).rang == USER_RANK_ADMIN ? "admin" : "consultation";
        localStorage.setItem("view_mode", mode);
        dispatch({ type: UPDATE_VIEW_MODE, payload: mode });

        history.push("/");
      })
      .catch(() => {
        dispatch({ type: LOGIN_ERROR, payload: {} });
      });
  };
}

function logout() {
  return function (dispatch) {
    dispatch({ type: LOGOUT_USER, payload: userService.logout() });
    dispatch(notificationActions.unsubscribe());
    history.replace("/login");
  };
}

function update(user) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      userService
        .update(user)
        .then((payload) => {
          if (payload.connected && payload.connected === true)
            dispatch({ type: UPDATE_USER, payload });
          resolve(payload);
        })
        .catch((error) => {
          reject("ERROR SAVE USER :", error);
        });
    });
  };
}

function updateCurrentUser(userData) {
  return function (dispatch, getState) {
    const { user } = getState();
    dispatch(update({ ...userData, id: user.infos.id }));
  };
}

function updateProfilePicture(doc) {
  return function (dispatch) {
    var user = JSON.parse(localStorage.getItem("user"));
    user.document = doc;
    localStorage.setItem("user", JSON.stringify(user));
    dispatch({ type: UPDATE_PROFILE_PICTURE, payload: doc });
  };
}

function updateViewMode(mode) {
  return function (dispatch) {
    localStorage.setItem("view_mode", mode);
    dispatch({ type: UPDATE_VIEW_MODE, payload: mode });
  };
}
